module.exports = __webpack_public_path__ + "img/lx1.8af37c47.png";